<template>
  <div>
    <Header></Header>
    <slideshow></slideshow>
    <div class="w">
      <div class="fanhui" @click="fnhui()">返回上一页</div>
      <div class="video_box">


          <video :src="url + list.video" class="video" controls></video> 
      </div>
      <div class="sxt">
        <span class="sxt_s" @click="tiaoshu(1)">上一条:{{ shangtitle }}</span>
        <span @click="tiaoshu(2)">下一条:{{ xiatitel }}</span>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import qs from "qs";
export default {
  components: {
    Header,
    Footer,
    slideshow,

  },
  data() {
    return {
      list: [],
      name: "",
      shang: "",
      shangtitle: "",
      xia: "",
      xiatitel: "",
      sp: "",
      id: "",
      url: this.$axios.defaults.baseURL,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.video(this.id)
    this.name = this.$route.query.name
    if (this.$route.query.sp) {
      this.sp = this.$route.query.sp
    }
  },
  methods: {
    tiaoshu(s) {
      if (s == 1) {
        if (this.shang == "没有上一条") {
          this.$alert("<strong>暂无上一条数据</strong>", "提示", {
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        this.getNext(this.shang);
      } else {
        if (this.xia == "没有下一条") {
          this.$alert("<strong>暂无下一条数据</strong>", "提示", {
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        this.getNext(this.xia);
      }
    },
    video: function (id) {
      this.$axios({
        // method: "post",
        // url: "index.php/show/showview",
        // data: qs.stringify({
        //   id: id,

        // }),
        method: "get",
        url: "/changhang/index/" + id,
      }).then((res) => {
        let data = res.data.data
        this.list = data;
        if (data.after) {
          this.shang = 1;
          this.shangtitle = data.after
        } else {
          this.shang = "没有上一条";
          this.shangtitle = "暂无"
        }
        if (data.next) {
          this.xia = 2;
          this.xiatitel = data.next
        } else {
          this.xia = "没有下一条";
          this.xiatitel = "暂无"
        }
        console.log(res, "aaaaa")
      })
    },
    getNext: function (id) {
      this.$axios({
        method: "get",
        url: "/changhang/index/afterOrNext?id=" + this.id + '&menu=1&type=4&afterOrNext=' + id,
      }).then(
        (res) => {
          this.id = res.data.data.id
          this.video(this.id)
        }
      )
    },
    fnhui() {
      this.$router.push({ path: "/corporateCulture?name=" + this.name + "&sp=" + this.sp });
    }
  }
}
</script>
<style scoped>
.sxt {
  /* display:flex; */

  text-align: center;
  cursor: pointer;
  margin: 1% auto;
}

.sxt_s {
  margin-right: 10%;
}

.w {
  width: 1000px;
  margin: auto;
}

.video_box {
  width: 100%;
  height: 650px;
  display: flex;

}

.video {
  width: 800px;
  height: 450px;
  margin: 0 auto;

}

.video_text {
  margin-top: 40px;
}

.fanhui {
  display: flex;
  width: 6vw;
  height: 3vw;
  text-align: center;
  line-height: 3vw;
  color: #000;
  font-size: 1vw;
  /* position: absolute; */
  z-index: 9999;
  margin-top: 12%;

}

.fanhui:hover {
  cursor: pointer
}

.imgs {
  width: 6vw;
  height: 1.5vw;
  position: relative;
  top: 190%;
  left: 210%;
}

.imgs:hover {}

.imgs img {
  width: 80%;
  height: 70%;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .w {
    width: 100%;
  }

  .fanhui {
    font-size: 12px;
    width: 200px;
    display: block;
    position: static;
    margin-top: 6%;
    margin-left: -10%;
  }

  .imgs {
    position: static;
    margin-top: 10%;
    width: 100px;
  }

  .xiams {
    position: static;
    margin-top: 10%;
    display: none;
  }

  .video {
    width: 80%;
    height: 200px;

    margin-top: 2%;
  }

  .video_box {
    height: 100%;
    margin-bottom: 5%;
  }

  .sxt {
    margin: 10px 10px;

    display: flex;
  }

  .sxt span {
    font-size: 12px;
    width: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/video/video.vue